const SSN_H = [6, 8];
const SSN_S = [8, 18];
const SSN_C = [18, 20];
const MOD97 = 97;
const SUBJECT_SERIAL_NUMBER_REGEXP = /^[0-9]{20}$/;


export function isValidSsnAny(ssnCandidate: string | number | boolean) {
  if (!ssnCandidate) {
    return true;
  }
  if (typeof ssnCandidate !== 'string') {
    return false;
  }
  return isValidSsn(ssnCandidate as string);
}

/**
 * Inspired from the FWK (UTILS project) Java-Bean Validation
 * @param ssnCandidate
 */
export function isValidSsn(ssnCandidate: string) {
  if (!ssnCandidate) {
    // use require to check if empty.
    return true;
  }

  if (!SUBJECT_SERIAL_NUMBER_REGEXP.test(ssnCandidate)) {
    return false;
  }

  const s = parseInt(ssnCandidate.substring(SSN_S[0], SSN_S[1]), 10);
  const c = parseInt(ssnCandidate.substring(SSN_C[0], SSN_C[1]), 10);

  return s % MOD97 === c;
}

export function isValidSsnWithBirthday(ssnCandidate: string, birthday: Date): boolean {
  if (birthday && isValidSsnAny(ssnCandidate)) {
    const var2 = parseInt(ssnCandidate.substring(SSN_H[0], SSN_H[1]), 10);
    const var3 = new Intl.DateTimeFormat('fr-FR', {day: '2-digit', month: '2-digit', year: 'numeric'}).format(birthday).replace(/\//g, '');
    return parseInt(var3, 10) % MOD97 === var2;
  } else {
    return false;
  }
}
